// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Activity as RawActivity } from "lucide-react";
export const Activity = /* @__PURE__ */ createIcon(RawActivity, "Activity", 2);
